<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid v-if="getPermissao('GESTAO_DE_CLIENTES')">

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 90px; padding-right: 90px;' : 'padding-top: 15px; padding-bottom: 10px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">

              <v-flex xs12 sm3 md2 lg1
                :style="filtroComputed.filtroTipoClienteString().length < 10 ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 10px;' : '' : !$vuetify.breakpoint.smAndDown ? `margin-right: ${(filtroComputed.filtroTipoClienteString().length/2.3) }%;` : ''"
              >
                <v-menu
                  v-model="filtro.tipoCliente.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroTipoClienteString() == 'Tipo'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroTipoClienteString()}}</v-btn>
                  <v-card max-width="200px">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="tipoCliente in filtro.tipoCliente.opcoes" :key="tipoCliente.id">
                        <v-btn
                          @click="filtroFunctions().selecionarTipoCliente(tipoCliente)"
                          :color="filtroComputed.tipoClienteSelecionadoDescricaoString() == tipoCliente.descricao ? 'primary' : 'themeGrey'"
                          round
                          block
                          :outline="filtroComputed.tipoClienteSelecionadoDescricaoString() != tipoCliente.descricao"
                        >{{tipoCliente.descricao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>
              
              <v-flex xs12 sm3 md2 lg1>
                <v-menu
                  v-model="filtro.status.opened"
                  :close-on-content-click="false"
                  offset-y transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroStatusString() == 'Status'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroStatusString()}}</v-btn>
                  <v-card :max-width="!$vuetify.breakpoint.smAndDown ? '170px' : ''">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="status in filtro.status.opcoes" :key="status.descricao">
                        <v-btn
                          @click="filtroFunctions().selecionarStatus(status)"
                          :color="filtroComputed.statusSelecionadoDescricaoString() == status ? 'primary' : 'themeGrey'"
                          round block
                          :outline="filtroComputed.statusSelecionadoDescricaoString() != status"
                        >{{status}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      v-if="!filtro.pesquisa.opened"
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe o CNPJ ou Razão Social do cliente"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>

              <v-spacer></v-spacer>
              
              <v-flex class="hidden-sm-and-down" md1 lg2 text-xs-right>
                <h3 class="primary--text">Gestão de Clientes</h3>
              </v-flex>
            
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container class="ml-82 mr-82 pa-24">
      <v-flex xs12>
        <v-layout row wrap class="scrollflex">
          <v-spacer></v-spacer>
          <v-btn class="right" color="secondary" round @click="go('Questionario')">Novo Cliente</v-btn>
          <br><br><br>
          <v-flex xs12 class="scrollflexcontent">
            <v-list class="pa-0" two-line>
              <v-toolbar height="56" color="primary">
                <v-flex xs5>
                  <v-toolbar-title class="subheading white--text">Razão Social</v-toolbar-title>
                </v-flex>
                <v-flex xs3 text-xs-center>
                  <v-toolbar-title class="subheading white--text">CNPJ</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Tipo</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Status</v-toolbar-title>
                </v-flex>
              </v-toolbar>
              <div v-for="cliente in cliente.listaPaginada" :key="cliente.idQar">
                <v-divider></v-divider>
                <v-list-tile  :id="'cliente-' + cliente.idQar" avatar>
                  <v-flex xs5>
                    <v-list-tile-sub-title :id="'cliente-' + cliente.idQar + '-razaoSocial'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="cliente.razaoSocial"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs3 text-xs-center>
                    <v-list-tile-sub-title :id="'cliente-' + cliente.idQar + '-cnpj'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="customFormatComputed.formatarCnpj(cliente.cnpj)"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'cliente-' + cliente.idQar + '-tipo'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="cliente.tipoCliente.descricao"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'cliente-' + cliente.idQar + '-ativo'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="cliente.ativo ? 'Ativo' : 'Inativo'"></v-list-tile-sub-title>
                  </v-flex>
                </v-list-tile>
              </div>
            </v-list>
            <br>
            <v-flex text-xs-center>
              <v-pagination
                v-model="paginacao.atual"
                :length="paginacao.numPaginas"
                :total-visible="7"
                circle
              ></v-pagination>
            </v-flex>
            <br>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import CustomFormat from '@/helpers/custom-format';
import permissoes from '@/helpers/permissoes';
import usuarioHelper from '@/helpers/usuario-logado.js';

export default {
  name: 'GestaoClientes',
  data () {
    return {
      on: null,
      mapaPermissoes: null,
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        status: {
          opened: false,
          opcoes: ["Todos", "Ativo", "Inativo"],
          selecionado: null
        },
        tipoCliente: {
          opened: false,
          opcoes: [ {id: 0, descricao: 'Todos os tipos'}, {id: 1, descricao: 'Transportador'}, {id: 2, descricao: 'Embarcador'} ],
          selecionado: null
        }
      },
      paginacao: {
        atual: 1,
        numPaginas: 1
      },
      cliente: {
        lista: [],
        listaFiltro: [],
        listaPaginada: []
      }
    }
  },
  computed: {
    filtroComputed: function() {
      const self = this;
      return {
        filtroTipoClienteString: function() {
          if (self.filtro.tipoCliente.selecionado) {
            return self.filtro.tipoCliente.selecionado.descricao;
          } else {
            return 'Tipo';
          }
        },
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return 'Status';
          }
        },
        tipoClienteSelecionadoDescricaoString: function() {
          if (self.filtro.tipoCliente.selecionado) {
            return self.filtro.tipoCliente.selecionado.descricao;
          } else {
            return '';
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return '';
          }
        }
      }
    },
    customFormatComputed: function() {
      return CustomFormat;
    }
  },
  watch: {
    "paginacao.atual": function(val) {
      this.filtroFunctions().aplicarFiltros(val);
    },
    "filtro.tipoCliente.selecionado": function(val) {
      this.filtroFunctions().aplicarFiltros();
    },
    "filtro.status.selecionado": function(val) {
      this.filtroFunctions().aplicarFiltros();
    },
    "filtro.pesquisa.conteudo": function(val) {
      this.filtroFunctions().aplicarFiltros();
    }
  },
  mounted: function() {
    this.mapaPermissoes = permissoes.getMapaPermissoes();
    this.buscarClientes();
  },
  methods: {
    getPermissao: function(requerida) {
      const self = this;
      if (requerida) {
        if (self.mapaPermissoes) {
          return self.mapaPermissoes.get(requerida);
        }
      }
      return false;
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({name: routeName});
      } else {
        self.$router.push({name: routeName, params: routeParams});
      }
    },
    buscarClientes: function () {
      const self = this;
      if (self.getPermissao('GESTAO_DE_CLIENTES')) {
        self.$store.commit('startLoading');
        axios.get(`${process.env.URL_QAR}/v1/qar-transportadora/itens-lista/modelos-simplificados`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
        })
        .then((response) => {
          self.cliente.lista = response.data;
          self.cliente.listaFiltro = response.data;
          self.filtroFunctions().aplicarFiltros();
          self.$store.commit('endLoading');
        })
        .catch(err => {
          self.$store.commit('endLoading');
        });
      }
    },
    toLocaleString: function (datetime) {
      return CustomFormat.toLocaleDateTimeString(datetime);
    },
    filtroFunctions: function() {
      const self = this;
      return {
        aplicarFiltros: function (paginaAtual) {
          const pesquisa = self.filtro.pesquisa.conteudo;
          self.cliente.listaFiltro = JSON.parse(JSON.stringify(self.cliente.lista));

          if (self.filtro.tipoCliente.selecionado && self.filtro.tipoCliente.selecionado.id != 0) {
            self.cliente.listaFiltro = self.cliente.listaFiltro.filter((cliente) => {
              return cliente.tipoCliente.id == self.filtro.tipoCliente.selecionado.id;
            });
          }

          if (self.filtro.status.selecionado && self.filtro.status.selecionado != 'Todos') {
            self.cliente.listaFiltro = self.cliente.listaFiltro.filter((cliente) => {
              return self.filtro.status.selecionado == 'Ativo' ? cliente.ativo : self.filtro.status.selecionado == 'Inativo' ? !cliente.ativo : cliente;
            });
          }
          
          if (pesquisa && pesquisa.length > 0) {
            self.cliente.listaFiltro = self.cliente.listaFiltro.filter((cliente) => {
              return  cliente.cnpj.toUpperCase().includes(pesquisa.toUpperCase())
                      ||
                      cliente.razaoSocial.toUpperCase().includes(pesquisa.toUpperCase())
            });
          }
          this.aplicarPaginacao(paginaAtual);
        },
        aplicarPaginacao: function(paginaAtual) {
          self.paginacao.numPaginas = Math.ceil(self.cliente.listaFiltro.length/10);
          self.paginacao.atual = paginaAtual ? paginaAtual : 1;
          self.cliente.listaPaginada = [];

          let count = (self.paginacao.atual * 10) - 10;
          let limiteMin = (self.paginacao.atual * 10) - 10;
          let limiteMax = limiteMin + 10;

          if (self.paginacao.atual <= self.paginacao.numPaginas) {
            for (let i = limiteMin; i < limiteMax; i++) {
              if (self.cliente.listaFiltro[i]) {
                self.cliente.listaPaginada.push(self.cliente.listaFiltro[i]);
              }
              limiteMin++;
            }
          }

          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        },
        selecionarTipoCliente: function(tipoClienteSelecionado) {
          self.filtro.tipoCliente.selecionado = tipoClienteSelecionado;
          self.filtro.tipoCliente.opened = false;
        },
        selecionarStatus: function(status) {
          if (status) {
            self.filtro.status.selecionado = status;
            self.filtro.status.opened = false;
          }
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.scrollflex {
  overflow-x: auto;
}
.scrollflexcontent {
  min-width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/gestao-clientes/GestaoClientes.vue